import { StructuredStorageBaseHelper } from './StructuredStorageBaseHelper';
export class CreateValIterableIteratorStructuredStorageHelper extends StructuredStorageBaseHelper {
    emit(sb, node, optionsIn) {
        sb.emitHelper(node, optionsIn, sb.helpers.createIterableIteratorStructuredStorageBase({
            type: this.type,
            handleNext: (innerOptions) => {
                sb.emitHelper(node, sb.pushValueOptions(innerOptions), sb.helpers.handleValValueStructuredStorage);
            },
        }));
    }
}

//# sourceMappingURL=CreateValIterableIteratorStructuredStorageHelper.js.map
